import { useMemo } from 'react';
import { useGetOffices } from '@/api/useGetOffices';

interface UseOfficeFieldConfigProps {
  placeholder?: string;
  config?: Record<string, unknown>;
  fieldProps?: Record<string, unknown>;
}

export function useOfficeFieldConfig(props: UseOfficeFieldConfigProps) {
  const { offices = [] } = useGetOffices();

  const options = useMemo(
    () =>
      offices.map((o: { id: number; name?: string; location?: string }) => ({
        value: String(o.id),
        label: o.name ?? o.location ?? `Office ${o.id}`,
        description: o.location,
      })),
    [offices]
  );

  const fieldConfig = useMemo(
    () => ({
      type: 'select' as const,
      name: 'office',
      label: 'Office Address',
      required: true,
      options,
      condition: {
        operator: 'equal',
        field: 'location',
        value: 'onsite',
      },
      ...(props.config || {}),
      fieldProps: {
        placeholder: props.placeholder ?? 'Select office...',
        ...(props.fieldProps || {}),
      },
    }),
    [props, options]
  );

  return { fieldConfig, options };
}
